(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('InfectionPrimaryAccess', InfectionPrimaryAccess);

    InfectionPrimaryAccess.$inject = ['$resource'];

    function InfectionPrimaryAccess ($resource) {
        var resourceUrl =  'api/infection-primary-accesses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
